export const LOGIN_SUCCESS = "login_success";
export const LOGOUT = "LOGOUT";
export const LOADER = "loader";
export const SET_SELECTED_ROLE = "set_selected_role";
export const SET_SELECTED_FORM_ID = "set_selected_form_id";
export const GET_DEPARTMENT_FORM_SUCCESS = "get_department_form_success";   
export const IS_ANSWERED = "is_answers";   
export const SET_MAIN_FLOW_ID = "set_main_flow_id";
export const SET_VIEW_ANNOUNCEMENT = "set_view_announement";
export const SET_SELECTED_FLOW_ID = "set_selected_flow_id";
export const SET_SUB_TICKET_ID = "set_sub_ticket_id";
export const USERMODALS = "USERMODALS";
export const SET_FORM_BUILDER_VALUES = 'SET_FORM_BUILDER_VALUES';
export const GROUPMODALS = 'GROUPMODALS';
export const SETGROUPLIST = "SETGROUPLIST";
export const IS_EDIT = 'is_edit';
export const MEMBERMODAL = 'MEMBERMODAL';


export const SET_FORM_BUILDER_MODE = 'SET_FORM_BUILDER_MODE';
export const SET_CREATE_FORM_GROUP_LIST = 'SET_CREATE_FORM_GROUP_LIST';
export const SET_CONFIGURATION_LIST = 'SET_CONFIGURATION_LIST';
export const SET_FILTER_LIST='SET_FILTER_LIST';
export const SET_DATA_TYPE='SET_DATA_TYPE';
export const SET_JOB_SCHEDULE="SET_JOB_SCHEDULE"
export const SET_PROVISION_TYPE='SET_PROVISION_TYPE';

